import { render } from "./model-footer.vue?vue&type=template&id=ffb7698a"
import script from "./model-footer.vue?vue&type=script&lang=js"
export * from "./model-footer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__